import axios from "axios";
import API_BASE_URL from "../config/config.js";

/**
 * PURPOSE:
 * Consumir cumulative_table desde el frontend público.
 *
 * RESPONSIBILITIES:
 * - Obtener la tabla acumulada por idevent.
 * - Mantener el consumo HTTP aislado de la UI.
 *
 * COLLABORATORS:
 * - src/sections/TablaAcumuladaSection.jsx
 * - src/config/config.js
 *
 * ROUTE:
 * src/services/cumulativeTable.js
 */

export const getCumulativeSeriesByEvent = async (idevent) => {
  const response = await axios.get(
    `${API_BASE_URL}/cumulative-series/by-event/${idevent}`
  );
  return response.data;
};

export const getCumulativeTableByEvent = async (params) => {
  const idevent = typeof params === "object" ? params.idevent : params;
  const seriesId = typeof params === "object" ? params.seriesId : null;
  const response = await axios.get(`${API_BASE_URL}/getcumulativetable/${idevent}`, {
    params: seriesId ? { seriesId: Number(seriesId) } : undefined,
  });
  return response.data;
};
